import { Button } from '@shared/components';
import { VeeIcon } from './VeeIcon';

type AskVeeButtonProps = {
  onPress: () => void;
  isDisabled?: boolean;
};

export function AskVeeButton({ onPress, isDisabled }: AskVeeButtonProps) {
  return (
    <Button
      onPress={onPress}
      icon={<VeeIcon />}
      variant="vibrant"
      size="xs"
      isDisabled={isDisabled}
    >
      Ask Vee
    </Button>
  );
}
